
import api from '../../plugins/api';

const getTransmissions = (params) => {
  return api.get('/api/shop/getTransmissions', params);
};

export default getTransmissions;
